<template>
    <div>
        <preloader v-if="loading" :background="false" :display="loading" />
        <webhooks-form-template v-else :logs="logs" :form="form" :rules="rules" @submit="submit">
            <template #endpoint>
                <el-form-item prop="name" :error="errors.name">
                    <template #label>
                        <span class="gray-100">
                            {{ $l10n.__('Nom du webhook') }}
                        </span>
                    </template>
                    <el-input v-model="form.name"></el-input>
                </el-form-item>

                <el-form-item prop="endpoint" :error="errors.endpoint">
                    <template #label>
                        <span class="gray-100">
                            {{ $l10n.__('Endpoint personnalisé') }}
                        </span>
                    </template>
                    <el-input v-model="form.endpoint">
                        <template #prepend>
                            <i class="icon-link"></i>
                        </template>
                    </el-input>
                </el-form-item>
                <el-form-item prop="sign_key" :error="errors.sign_key">
                    <template #label
                        ><span class="gray-100">
                            {{ $l10n.__('Clé de signature') }}
                        </span></template
                    >
                    <el-input v-model="form.sign_key"></el-input>
                </el-form-item>
                <div class="webhook-http__config__actions">
                    <el-checkbox v-model="form.is_enabled">{{
                        $l10n.__('Webhook actif ?')
                    }}</el-checkbox>
                    <el-checkbox v-model="form.object_in_payload">{{
                        $l10n.__("Retourne l'objet dans le payload ?")
                    }}</el-checkbox>

                    <label class="webhook-http__config__actions__select--label">
                        {{ $l10n.__('Content-type') }}
                        <el-select
                            v-model="form.json_content_type"
                            class="webhook-http__select-content-type"
                        >
                            <el-option :value="false" label="application/x-www-form-urlencoded" />
                            <el-option :value="true" label="application/json" />
                        </el-select>
                    </label>
                </div>
            </template>
            <template #tagEvents="scopeEvents">
                {{ activeEvents(scopeEvents.currentLog.id) }} /
                {{ getAllEventsForParentLog(scopeEvents.currentLog.id).length }}
            </template>
            <!-- Logs events -->
            <template #events="scope">
                <div>
                    <el-table :data="getEventsConfigByLog(scope.log.id)" class="b-1" stripe>
                        <el-table-column prop="label" width="390">
                            <template #header>
                                <span class="regular">
                                    {{ getTableTitleByLog(scope.log) }}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column label="Webhook Event" prop="id">
                            <template #default="scopeId">
                                <div class="flex-level">
                                    <p>{{ getWebhookEventName(scopeId.row.id) }}</p>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            :label="$t.__('developerPage.WebhooksForms.Webhooks.activated')"
                            width="65"
                        >
                            <template #default="scopeEnabled">
                                <el-switch
                                    :modelValue="scopeEnabled.row.is_enabled"
                                    @change="(e) => handleSwitch(e, scopeEnabled.row)"
                                ></el-switch>
                            </template>
                        </el-table-column>
                    </el-table>

                    <!-- Child events to main Log -->
                    <div v-for="childLog of getLogsChildByLog(scope.log.id)" :key="childLog.id">
                        <el-table :data="getEventsConfigByLog(childLog.id)" class="b-1" stripe>
                            <el-table-column prop="label" width="390">
                                <template #header>
                                    <span class="regular">
                                        {{ getTableTitleByLog(childLog) }}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column label="Webhook Event" prop="id">
                                <template #default="scopeId">
                                    <div class="flex-level">
                                        <p>{{ getWebhookEventName(scopeId.row.id) }}</p>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                :label="$t.__('developerPage.WebhooksForms.Webhooks.activated')"
                                width="65"
                            >
                                <template #default="scopeEnabled">
                                    <el-switch
                                        :modelValue="scopeEnabled.row.is_enabled"
                                        @change="(e) => handleSwitch(e, scopeEnabled.row)"
                                    ></el-switch>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </template>
        </webhooks-form-template>
    </div>
</template>
<script>
import WebhooksFormTemplate from 'vcomponents/developerPage/WebhooksForms/WebhooksFormTemplate.vue';
import WebhooksMixins from 'vcomponents/developerPage/WebhooksForms/WebhooksMixins';
export default {
    components: {
        WebhooksFormTemplate,
    },
    mixins: [WebhooksMixins],
};
</script>

<style lang="scss">
.webhook-http {
    &__select-content-type {
        width: 280px;
    }
    &__config__actions {
        display: flex;
        align-items: center;

        &__select--label {
            display: flex;
            flex-direction: column;
        }
    }
}
</style>
